// Version de l'application - à incrémenter à chaque déploiement
export const APP_VERSION = "1.0.4";
export const BUILD_DATE = new Date().toISOString().split('T')[0];
